import {useNavigate} from "react-router";
import {useState} from "react";
import {Input, message} from "antd";
import config from "@/config";

export const ChangePassword = ({user}) => {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const navigate = useNavigate();

    const handleChangePassword = async (e) => {
        if (!password || !confirmPassword) {
            message.error('Vui lòng điền đầy đủ thông tin');
            return;
        } else if (password !== confirmPassword) {
            message.error('Mật khẩu không khớp');
            return;
        } else if (password === user.password) {
            message.error('Mật khẩu mới không được trùng với mật khẩu cũ');
            return;
        } else if (password.length < 6) {
            message.error('Mật khẩu phải có ít nhất 6 ký tự');
            return;
        }
        message.success('Đổi mật khẩu thành công', 1);
        navigate(config.routes.login);
    }
    return (
        <div className={"space-y-3"}>
            <div className={"space-y-2"}>
                <p className={"text-center"}>Xin chào, <span className={"text-red-500"}>{user.username}</span></p>
            </div>
            <div className={"space-y-2"}>
                <label className={"block text-sm font-medium"}>Mật khẩu mới<span
                    className={"text-red-500"}>*</span></label>
                <Input onChange={(e) => setPassword(e.target.value)} className={"w-full p-2 border rounded-md"}
                       placeholder="Nhập mật khẩu mới"/>
            </div>
            <div className={"space-y-2"}>
                <label className={"block text-sm font-medium"}>Nhập lại mật khẩu mới<span
                    className={"text-red-500"}>*</span></label>
                <Input onChange={(e) => setConfirmPassword(e.target.value)} className={"w-full p-2 border rounded-md"}
                       placeholder="Nhập lại mật khẩu mới"/>
            </div>
            <div className={"flex justify-center"}>
                <button
                    onClick={handleChangePassword}
                    className="px-6 py-2 w-1/2 bg-green-500 text-white rounded-md font-semibold hover:bg-green-800">
                    Đổi mật khẩu
                </button>
            </div>
        </div>
    )
}